module.exports = __webpack_public_path__ + "static/gallery_02-6be90228b29c6a57c9be8887aaef60d4.jpg";